import { useEffect, useState } from 'react';

export default function useDelayedState<T = boolean>(
  newState: T | boolean = true,
): T | boolean {
  const [current, set] = useState<T | boolean>(false);

  useEffect(() => set(newState));

  return current;
}
